import { render, staticRenderFns } from "./Inboundlist.vue?vue&type=template&id=c38eb31c&scoped=true&"
import script from "./Inboundlist.vue?vue&type=script&lang=js&"
export * from "./Inboundlist.vue?vue&type=script&lang=js&"
import style0 from "./Inboundlist.vue?vue&type=style&index=0&id=c38eb31c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c38eb31c",
  null
  
)

export default component.exports